module.exports = __webpack_public_path__ + "static/Michael-Compton-9656ea78b34231f193d476e49c91e36c.jpg";